export default {
  index: [
    {
      path: '/eszcnangh',
      component: resolve => require(['./eszcnanghIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/eszcnangh/_router.js